// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PLeftOutlinedSvg from "@fishx/icons-svg/es/asn/PLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var PLeftOutlined = function PLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PLeftOutlinedSvg
  }));
};

PLeftOutlined.displayName = 'PLeftOutlined';
export default React.forwardRef(PLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PLeftOutlined.js
// module id = 3477
// module chunks = 0